module.exports = __webpack_public_path__ + "static/media/Tiger596_3c.57526a60.svg";